import { OnbPageURLs, RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { openRequest } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestTypes/requestNavigation/requestsNavigationFunctions'

import { buildBPRegistrationFormUrl } from './buildBPRegistrationFormUrl'
import { TBPRegistrationRequest } from './createRegWithInitialData'

export const openCreatedBpRegistration = (
  { requestId, requestUid }: TBPRegistrationRequest,
  partnerName: string
) => {
  if (requestUid) {
    window.open(buildBPRegistrationFormUrl(requestUid), '_blank')
    return
  }

  openRequest({
    item: {
      EntryId: requestId,
      PartnerName: partnerName,
      Type: RequestTypes.BPRegistration,
    },
    url: OnbPageURLs.BPRegistration,
  })
}
